import { ContentTypes } from '@model/navigation';
import { SelectedOptions, SetOptions } from './NavBar';
import { DesktopNavigationContentComponent, DesktopNavigationContentProps } from './DesktopNavigationContent';
import { useTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { getNavDestinations, getNavOffers, getNavInfo } from '@state/cms';

export interface DesktopNavigationContentContainerProps {
  testId?: string;
  navContent: ContentTypes;
  selectedOptions: SelectedOptions;
  setOptions: SetOptions;
  onToggleDesktopNav?: () => void;
}

export const DesktopNavigationContentContainer = (ownProps: DesktopNavigationContentContainerProps) => {
  const props: DesktopNavigationContentProps = {
    theme: useTheme(),
    navDestinations: useSelector(getNavDestinations),
    navOffers: useSelector(getNavOffers),
    navInfo: useSelector(getNavInfo),
    ...ownProps
  };

  return <DesktopNavigationContentComponent {...props} />;
};
